/** PURE_IMPORTS_START .._.._Observable,.._.._observable_onErrorResumeNext PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { onErrorResumeNext as staticOnErrorResumeNext } from '../../observable/onErrorResumeNext';
Observable.onErrorResumeNext = staticOnErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/observable/onErrorResumeNext.js
// module id = 633
// module chunks = 0